"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeServices = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
function makeServices(services) {
    /**
     * Create default (empty) services context.
     * Eslint usually will block casting an Object Literal, we are disabling this
     * for the createContext call in the schematic.
     */
    const ServicesContext = react_1.default.createContext({}); // eslint-disable-line
    /**
     * Convenience component to provide services context.
     * @param contextProps - Allows for override of injected service dependencies.
     */
    const ServicesProvider = ({ contextProps = services, children }) => (react_1.default.createElement(ServicesContext.Provider, { value: contextProps }, children));
    const useServices = () => react_1.useContext(ServicesContext);
    return { ServicesProvider, useServices, ServicesContext };
}
exports.makeServices = makeServices;
//# sourceMappingURL=makeServices.js.map